import routes from '../../route_names'
import { getDefaultInterval } from '@/helpers/filter'

export default {
  path: 'projects/:projectId/campaigns/:campaignId/script',
  name: routes.SCRIPT,
  component: () =>
    import(/* webpackChunkName: "dashboard" */ './PublishView.vue'),
  meta: {
    layout: 'dashboard/DashboardLayout',
    requiresAuth: true,
    requiredRole: 'ADMIN',
    defaultChild: routes.SCRIPT_COPY
  },

  children: [
    {
      path: 'copy',
      name: routes.SCRIPT_COPY,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './Script.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    },
    
  ]
}
